import "./VideoComponent.scss";
import React, { useMemo, useState } from "react";
import { Howl } from "howler";
import { MdOutlineAudiotrack } from "react-icons/md";

const App = ({ handleSkip }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstPlay, setIsFirstPlay] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const sound = useMemo(() => {
    return new Howl({
      src: ["assets/ShowVerse07.mp3"],
    });
  }, []);

  const handleAudio = () => {
    console.log(isPlaying);
    sound.mute(isPlaying);

    if (!isFirstPlay) {
      setIsFirstPlay(true);
      sound.play();
      sound.volume(0.2);
    }
    setIsPlaying((value) => !value);
  };

  const delaySkip = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1200));
    handleSkip();
    sound.stop();
  };

  return (
    <>
      <div className="videoContainer">
        <video className="videoContent" muted autoPlay onEnded={delaySkip}>
          <source src="assets/ShowVerse07.mp4" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
        <div
          className={`audio_container${isFirstPlay ? " fade" : " fade"}${isPlaying ? " playing" : ""}`}
          onClick={handleAudio}
        >
          <MdOutlineAudiotrack size={"28px"} />
        </div>
        <div className="skip" onClick={delaySkip}>
          <p>SKIP</p>
        </div>
      </div>
      <div className={`fader${isLoading ? " out" : ""}`} />
    </>
  );
};

export default App;
